import { Dispatch, SetStateAction, useState } from "react"
import FormErrors from "components/formParts/formErrors"
import { useTranslation } from "react-i18next"
import { CustomInputGroup, CustomInputGroups } from "types"
import { filterInputName } from "utils/filter"
import TextInput from "components/inputs/textInput"
import useLayout from "hooks/useLayout"
import Form from "components/forms/form"
import { ReactComponent as AddIcon } from "assets/icons/add.svg"
import Callout from "components/callout/callout"
import Button from "components/inputs/button"
import ButtonGroup from "components/buttons/buttonGroup"
import Section from "components/layout/section"

interface AddCustomInputGroupFormProps {
    setGroups: Dispatch<SetStateAction<CustomInputGroups>>
    setCustomInputGroupOrder: Dispatch<SetStateAction<string[]>>
    groups: CustomInputGroups
}

const AddCustomInputGroupForm: React.FC<AddCustomInputGroupFormProps> = ({ setGroups, groups, setCustomInputGroupOrder }) => {

    const { t } = useTranslation()

    const [errors, setErrors] = useState<string[]>([]);
    const [name, setName] = useState<string>(``)

    const {
        closeDialog
    } = useLayout()

    // Handle form submission.
    const handleSubmit = () => {
        // Check if the name is already in use.
        if (Object.keys(groups).includes(name)) {
            setErrors([t('nameAlreadyExists')])
            return
        }
        // Create new group.
        const newGroups = {
            ...groups,
            [name]: {
                customInputOrder: [],
                customInputs: {}
            } as CustomInputGroup
        }
        // Add the group.
        setGroups(newGroups)
        // Add the group to the order.
        setCustomInputGroupOrder(order => {
            return [...order, name]
        })
        // Close the dialog.
        closeDialog()
    }

    // Handle name change.
    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setName(filterInputName(event.target.value, false, 30, true))
    }

    // Handle keydown event for Enter key
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            handleSubmit()
        }
    }

    // Return the JSX.
    return (
        <div
            className={`group`}
            onKeyDown={handleKeyDown}>
            <Section>

            <Callout type={`info`} id={`addCustomInputGroupInfo`}>
                <p>{t('addCustomInputGroupInfo')}</p>
            </Callout>

            <TextInput label={t('name')} value={name} onChange={handleNameChange} required />

            <ButtonGroup>
                <Button wideOnMobile type="button" design="primary" onClick={handleSubmit}><AddIcon /><span>{t('buttonAddGroup')}</span></Button>
            </ButtonGroup>

            {errors.length > 0 && <FormErrors errors={errors} />}
            </Section>
        </div>
    )

}

export default AddCustomInputGroupForm



